define('modules/faq',['jquery'], function ($) {
    function Faq(faqContainer) {
      this.$faq = faqContainer;
      this.$itemscontainer = faqContainer.find('.faq_field');
    }
    Faq.prototype.init = function () {
      var _this = this;
  
      if ($('.viewMoreFaq_btn').length) {
        $('.faq_list').hide();
      } else {
        $('.faq_list').show();
      }
  
      this.$faq.on('click', '.viewMoreAnswer_btn', function (e) {
        var currentAnswer = $(this).parent().next();
        if ($(currentAnswer).is(':visible')) {
          $(currentAnswer).hide();
          $(this).text('+');
        } else {
          $(currentAnswer).show();
          $(this).text('-');
        }
      });
      this.$faq.on('click', '.viewMoreFaq_btn', function (e) {
        var current = $(this).parent().next();
        if ($(current).is(':visible')) {
          $(current).hide();
          $(this).text('<');
        } else {
          $(current).show();
          $(this).text('˅');
        }
      });
    };
    return Faq;
  });
  
